define(["./ElementsPathParser", "./ElementsPathUtils"],
	function(Parser, ElementsPathUtils) {
		var hasWildcard = function(value){
			return value.indexOf("*") != -1;
		};

		var filterClassList = function(classList, prefixes){
			if(prefixes){
				classList = classList.filter(function(className){
					for(var i = 0;i < prefixes.length;i++){
						if(className.indexOf(prefixes[i]) == 0){
							return false;
						}
					} 
					return true;
				})
			}	
			return classList	
		}

		var makePartialSelector = function(classNameMask){
			var result = "",
				parts = classNameMask.split("*");
			//Can only support startWith partials?	
			if(parts[0].length > 2){
				result = '[class^="' + parts[0] + '"]';
			}	
			return result;
		}

		var GENERIC_QUERIES = {
			"div": true,
			"span": true,
			"*": true
		}

		var CLASS_SEPARATOR_REGEX = /[ \t\n\r]+/;
		
		var ElementsFinder = function(){
			this.parser = new Parser();
			this.ignoredElement = "uConsole";

			if(window.uDash){
				var uDashSettings = window.uDash._globalSettings;
				if(uDashSettings){
					this.prefixes = uDashSettings.uIgnoreClassNamesWithPrefix;
				}
			}

			this.constructSelector = function(path){
				var selectors = [],
					immediateParent = false;
				//try to construct selector which is closest possible to the path
				for(var i = 0; i < path.length;i++){
					var pathPart = path[i],
						elementId = pathPart.elementId,
						tagName = pathPart.tagName,
						childIndex = pathPart.childIndex,
						classList = pathPart.classList,				
						currentSelector = "",
						pathPartString = pathPart.pathPartString;
					if(elementId != "" && hasWildcard(elementId) === false){
						//full id available
						currentSelector = "#" + elementId;
					}
					else{
						if(tagName != "" && hasWildcard(tagName) === false){
							currentSelector = currentSelector + tagName;
							/*if(childIndex == -1){
								//HACK
								currentSelector = currentSelector + "nonExistingSelector";
							}*/
						};
						if(childIndex > 0){
							currentSelector = currentSelector +  ":nth-child(" + childIndex +  ")";
						};
                        if (classList.length>0){
                            var classWithWildcard = false;
                            for(var j = 0; j < classList.length;j++){
                                var className = classList[j];
                                if (hasWildcard(className)){
                                    classWithWildcard = true;
                                    break;
                                }
                            };
                            if (!classWithWildcard){
                                currentSelector = currentSelector + '.'+classList.join('.');
                            }else{
                                currentSelector = currentSelector + makePartialSelector(classList.join(' '));
                            }
                        }
					};
					var immediateChild = pathPartString.charAt(0) != "*";
					if(currentSelector != ""){
						if(immediateParent && immediateChild)
							selectors.push(">");
						selectors.push(currentSelector);
						immediateParent = pathPartString.charAt(pathPartString.length - 1) != "*";						
					}
					else{
						immediateParent = false;
					}
				};
				var selectorsString = selectors.join(" ");
				if(immediateParent === false && selectorsString != ""){
					//Select element and all its children
					selectorsString = selectorsString + "," + selectorsString + " *";
				};
				return selectorsString;				
			},
			this.getElementShortPath = function(element){
				var path = [];
				//Do not include child indexes in the path
				//Those are matched in the query selector builder
				while(element){
					var tagName = element.tagName,
						className = element.className,
						elementId = element.id,
						pathPart = tagName + "[*]";
					if(className){
						if(typeof className !== "string"){
							if("baseVal" in className){
								//Check for SVGAnimatedString
								className = className.baseVal;
							}		
							else{
								className = null;
							}						
						}
						else{
							className = className.trim();							
						}
					}		
					if(elementId){
						pathPart = pathPart +  "#" + elementId;
					}
					if(className){
						var classList = className.split(CLASS_SEPARATOR_REGEX);
						classList = filterClassList(classList, this.prefixes);
						if(classList.length){
							pathPart = pathPart + "." +  classList.join('.');
						}
					}
					path.push(pathPart);
					if(element.tagName == "HTML"){
						element = null
					}
					else{
						element = element.parentNode;
					}
				}
				return path.reverse().join("/");
			},
			this.search = function(pathString,findOne){
                pathString = pathString.replace(/ /g, "");
				var elementsPath = this.parser.parse(pathString),
					selectors = this.constructSelector(elementsPath),
					elements = [],
					list;
				if(elementsPath.length == 0)
					return elements;
				if(selectors == ""){
					//Worst possible case - all elements are wild cards
					throw new Error("Your query is too generic");
					//list = document.querySelectorAll("body *");
				}
				else{
					if(selectors in  GENERIC_QUERIES){
						throw new Error("Your query is too generic");
					}
					if(selectors.indexOf("body") !== 0){
						selectors = "body " + selectors;	
					}
					list = document.querySelectorAll(selectors);
                    
				}
				//Child indexes
				pathString = pathString.replace(/\[([^\]]+)]/g, "[*]");
				var pathRegex = new ElementsPathUtils().getPathRegex(pathString);
				
				//HACK - to exclude children of uConsole
				var uConsole = document.getElementById(this.ignoredElement);
				//Filter out elements not matching to wildcards
				var ignoredElements = {"SCRIPT": true, "BR": true};
				for(var i = 0; i < list.length;i++){
					var element = list.item(i);
					if(uConsole && uConsole.contains(element))
						continue;
					if(element.tagName in ignoredElements)
						continue;
					var elementPath = this.getElementShortPath(element);
					if(pathRegex.test(elementPath)){
						elements.push(element);	
                        if (findOne) break;
					}
				}
				return elements;
			}
		};
		return ElementsFinder;
	}
);


//////////////////
// WEBPACK FOOTER
// ./utils/ElementsFinderByPath.js
// module id = 5
// module chunks = 0